import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const PeopleRecordsPage = loadable(() => import('./PeopleRecordsPage'));
export default {
    id: 'people_records',
    title: 'People Records',
    icon: 'user',
    route: 'people-records',
    defaultRoute: 'people-records/person-database',
    group: 'administration',
    component: PeopleRecordsPage,
    order: 6,
    structure,
};
